import { render, staticRenderFns } from "./salinvoiceshipnotedetail.vue?vue&type=template&id=0d17a561&scoped=true&"
import script from "./salinvoiceshipnotedetail.vue?vue&type=script&lang=js&"
export * from "./salinvoiceshipnotedetail.vue?vue&type=script&lang=js&"
import style0 from "./salinvoiceshipnotedetail.vue?vue&type=style&index=0&id=0d17a561&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17a561",
  null
  
)

export default component.exports